module.exports = " <div class=weui_dialog_alert @touchmove=\"!this.scroll && $event.preventDefault()\"> <div class=weui_mask @click=\"hideOnBlur && (show = false)\" v-show=show :transition=maskTransition></div> <div class=weui_dialog v-show=show :transition=dialogTransition> <slot></slot> </div> </div> ";


//////////////////
// WEBPACK FOOTER
// ./~/.1.2.3@vue-html-loader!./~/.8.7.0@vue-loader/lib/selector.js?type=template&index=0!./~/.0.1.3@vux/src/components/dialog/index.vue
// module id = 220
// module chunks = 2